<template>
  <div class="neon poster">
    <transition name="slowFade">
      <div v-if="hasSkyline" class="skyline"></div>
    </transition>
    <transition name="slowFade" v-if="meetingStore.initTitleCardShown && usersStore.firstShown">
      <div class="propsFrame poster">
        <avatars-sofa />
        <transition name="basic">
          <div v-if="hasCoffeeTable" class="coffeeTable" :style="tableStyle"></div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import AvatarsSofa from '@/components/AvatarsSofa';

import { useFrameStore } from '@/store/pinia/frame';
import { useMeetingStore } from '@/store/pinia/meeting';
import { usePhaseStore } from '@/store/pinia/phase';
import { useUsersStore } from '@/store/pinia/users';

const frameStore = useFrameStore();
const meetingStore = useMeetingStore();
const phaseStore = usePhaseStore();
const usersStore = useUsersStore();

const { positions: userPositions, positionDetails, myId, iAmInWaitingRoom, firstShown, iAmAway } = storeToRefs(usersStore);
const { currentPhase, isPresentation } = storeToRefs(phaseStore);
const { contWidth, pxToRem } = storeToRefs(frameStore);

const hasSkyline = computed(() => {
  if (!firstShown.value) {
    return false;
  }

  if (positionDetails.value.layoutName === 'couch' || iAmAway.value || iAmInWaitingRoom.value) {
    return false;
  }
  if (['waiting', 'lobby', 'endMeeting', 'finish', 'ended', 'input'].includes(currentPhase.value) || isPresentation.value) {
    return false;
  }
  return true;
});

const hasCoffeeTable = computed(() => {
  return iAmAway.value || iAmInWaitingRoom.value;
});

const tableStyle = computed(() => {
  let css = {
    left: contWidth.value - (positionDetails.value.left + positionDetails.value.width) + 'px',
    top: positionDetails.value.bottom + 'px',
  };

  if (iAmInWaitingRoom.value) {
    const { w, top, left } = userPositions.value[myId.value];
    css.width = w + pxToRem.value(20) + 'px';
    css.top = top + w * 0.4 + 'px';
    css.left = left + css.width / 2 + 'px';
    css.bottom = 'auto';
  }

  return css;
});
</script>
<style lang="scss" scoped>
.skyline {
  width: 100%;
  background-repeat: repeat-x;
  background-size: contain;
  height: 20%;
  position: absolute;
  top: 50%;
  background-image: url($base-url + '/assets/images/spaces/neon/skyline.svg');
  z-index: 10;
  display: block;
}

.propsFrame {
  @include sidebar-response;
}

.coffeeTable {
  position: absolute;
  //left: 33.333%;
  z-index: 90;
  pointer-events: none;
  transform: translateY(-15.5%);
  aspect-ratio: 564 / 525;
  width: math.div(192, $design-height) * 100vh;
  width: calc(var(--vh, 1vh) * (192 / #{$design-height}) * 100);
  // height: math.div(187, $design-height) * 100vh;
  // height: calc(var(--vh, 1vh) * (187 / #{$design-height}) * 100);
  display: block;
  transition: all 500ms cubic-bezier(0.45, 0, 0.55, 1);

  &:before,
  &:after {
    position: absolute;
    content: '';
    display: block;
  }

  &:after {
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-image: url($base-url + '/assets/images/spaces/neon/neon-coffee-table.png');
  }

  &:before {
    bottom: -3px;
    height: 5px;
    background: var(--c__shadow-opaque);
    box-shadow: 0 0 10px var(--c__shadow-opaque), 0 0 5px var(--c__shadow-opaque), 0 0 3px var(--c__shadow-opaque);
    left: -1em;
    right: -1em;
    border-radius: 50%;
    z-index: -1;
  }
}
</style>
